import { useEffect, useState, Suspense } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { getApiUrl } from '@/lib/apiUrl'


function PaymentSuccessContent() {
	const [params] = useSearchParams()
	const navigate = useNavigate()
	const [message, setMessage] = useState('Confirming your payment...')

	useEffect(() => {
		const run = async () => {
			const sessionId = params.get('session_id')
			if (!sessionId) {
				setMessage('Missing payment session.')
				return
			}

      try {
        // Confirm payment through backend
        const apiUrl = getApiUrl()
        const confirmUrl = `${apiUrl}/payments/confirm/${sessionId}`
        console.log('🔍 Confirming payment:', { sessionId, apiUrl, confirmUrl })
        
        const res = await fetch(confirmUrl, {
          method: 'GET',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
        })
        
        console.log('📡 Payment confirmation response:', { status: res.status, statusText: res.statusText, url: res.url })
        // Check if response is actually JSON
        const contentType = res.headers.get('content-type')
        if (!contentType || !contentType.includes('application/json')) {
          console.error('API returned non-JSON response:', contentType)
          const text = await res.text()
          console.error('Response body:', text.substring(0, 500))
          setMessage('Server error: Expected JSON response but got HTML. Check console for details.')
          return
        }

        const data = await res.json()
        if (!res.ok) {
          console.error('Payment confirmation failed:', data)
          const errorMsg = data?.error || 'Payment could not be confirmed.'
          const details = data?.details ? ` (${data.details})` : ''
          setMessage(`${errorMsg}${details}`)
          return
        }
        setMessage('Payment confirmed! Your payment is held in escrow. You can now chat with the landlord.')
        // Refresh payment history and application status
        setTimeout(() => {
          navigate('/dashboard/client')
          // Trigger a page refresh to update payment status
          window.location.reload()
        }, 2000)
      } catch (error: any) {
				console.error('Payment confirmation error:', error)
				setMessage(`There was a problem confirming your payment: ${error.message || 'Unknown error'}`)
			}
		}
		run()
	}, [params, navigate])

	return (
		<div className="min-h-screen flex items-center justify-center bg-gray-50">
			<div className="bg-white p-8 rounded shadow text-center">
				<h1 className="text-2xl font-bold mb-2">Payment Success</h1>
				<p className="text-gray-700">{message}</p>
			</div>
		</div>
	)
}

export default function PaymentSuccessPage() {
	return (
		<Suspense fallback={
			<div className="min-h-screen flex items-center justify-center bg-gray-50">
				<div className="bg-white p-8 rounded shadow text-center">
					<h1 className="text-2xl font-bold mb-2">Payment Success</h1>
					<p className="text-gray-700">Loading...</p>
				</div>
			</div>
		}>
			<PaymentSuccessContent />
		</Suspense>
	)
}



